export default __webpack_public_path__ + "static/media/cm_5.3441167d.png";